export var CropRatio;
(function (CropRatio) {
    CropRatio["Free"] = "free";
    CropRatio["Original"] = "original";
    CropRatio["Square"] = "square";
    CropRatio["R16_9"] = "16:9";
    CropRatio["R4_3"] = "4:3";
    CropRatio["R3_2"] = "3:2";
})(CropRatio || (CropRatio = {}));
export var TransformationKind;
(function (TransformationKind) {
    TransformationKind["FreeRotate"] = "freeRotate";
    TransformationKind["Crop"] = "crop";
    TransformationKind["AspectRatio"] = "aspectRatio";
    TransformationKind["Orientation"] = "orientation";
    TransformationKind["None"] = "none";
})(TransformationKind || (TransformationKind = {}));
export var FileSource;
(function (FileSource) {
    FileSource["Private"] = "private";
    FileSource["PrivateUser"] = "privateUser";
    FileSource["Public"] = "public";
})(FileSource || (FileSource = {}));
export var MediaImageStudioMode;
(function (MediaImageStudioMode) {
    MediaImageStudioMode["Default"] = "";
    MediaImageStudioMode["Transform"] = "transform";
    MediaImageStudioMode["Filters"] = "filters";
    MediaImageStudioMode["Adjust"] = "adjust";
    MediaImageStudioMode["Cutout"] = "cutout";
    MediaImageStudioMode["Generate"] = "generate";
    MediaImageStudioMode["AiEditing"] = "aiEditing";
})(MediaImageStudioMode || (MediaImageStudioMode = {}));
export var AutoEnhanceVersion;
(function (AutoEnhanceVersion) {
    AutoEnhanceVersion["v1_4"] = "1.4";
    AutoEnhanceVersion["v1_5"] = "1.5";
    AutoEnhanceVersion["v1_6"] = "1.6.1";
})(AutoEnhanceVersion || (AutoEnhanceVersion = {}));
export var ImageSource;
(function (ImageSource) {
    ImageSource["Predefined"] = "predefined";
    ImageSource["Private"] = "private";
    ImageSource["Public"] = "public";
    ImageSource["Unsplash"] = "unsplash";
    ImageSource["Unknown"] = "unknown";
})(ImageSource || (ImageSource = {}));
//# sourceMappingURL=commonTypes.js.map